import { useLayoutEffect, useState } from "react";
export var useContainerWidth = function (ref) {
    var _a = useState(null), width = _a[0], setWidth = _a[1];
    useLayoutEffect(function () {
        var element = ref.current;
        if (!element) {
            return undefined;
        }
        var update = function () { return setWidth(element.getBoundingClientRect().width); };
        update();
        var observer = new ResizeObserver(update);
        observer.observe(element);
        return function () { return observer.disconnect(); };
    }, [ref]);
    return width;
};
